import classNames from "classnames";
import { badgeClassName } from "../../elements/badgeClassName";
import { FieldMessage, helpTextId } from "./FieldValue";
import { StatusBadgeFieldProps } from "./StatusBadgeField.types";

const EMPTY_VALUE_PLACEHOLDER = "—";

/**
 * A system-computed value, so unlike the rest of this folder it renders read-only. The
 * status-to-colour mapping comes from the caller's `variant`, and status is conveyed by
 * text rather than colour alone.
 */
export function StatusBadgeField({
  label,
  value,
  name,
  variant = "secondary",
  helpText,
  className = "",
}: StatusBadgeFieldProps) {
  return (
    <div className={classNames("field-value", className)}>
      <div className="field-value__label form-label">{label}</div>
      {value ? (
        <span className={badgeClassName(variant)}>{value}</span>
      ) : (
        EMPTY_VALUE_PLACEHOLDER
      )}
      {helpText && (
        <p
          id={helpTextId(name ?? "")}
          className="form-text small text-body-secondary mb-0"
        >
          {helpText}
        </p>
      )}
      <FieldMessage name={name ?? ""} />
    </div>
  );
}
